




































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { handleRetain } from "../../../../../common/untils/formData";
const win: any = window;
@Component({
  components: {},
  filters: {
    changeFilter(value: any) {
      if (value > 0) {
        return "+" + handleRetain(value, 2) + "%";
      } else if (value < 0) {
        return handleRetain(value, 2) + "%";
      } else if(value == 0){
        return value + "%";
      }else{
        return '--'
      }
    }
  }
})
export default class PopupSlot extends Vue {
  @Prop({
    default: [
      { name: "化工新材料", count: "14", raise: "+9.55%", id: "block0" },
      { name: "旅游", count: "114", raise: "+9.55%", id: "block1" },
      { name: "锂电池", count: "14", raise: "+9.55%", id: "block2" },
      { name: "化工新材料", count: "14", raise: "+9.55%" },
      { name: "化工新材料", count: "14", raise: "+9.55%" },
      { name: "化工新材料", count: "14", raise: "+9.55%" },
      { name: "化工新材料", count: "14", raise: "+9.55%" },
      { name: "化工新材料", count: "14", raise: "+9.55%" },
      { name: "化工新材料", count: "14", raise: "+9.55%" }
    ]
  })
  private readonly listItem?: Array<any>;
  private maidian = "free_ztjj.zqfk.all";

  @Emit("scrollPos")
  private handlePosition(itemId: string, index: number) {
    win.hxmClickStat(`${this.maidian}.${index + 1}`, { url_ver: "F10-1725" });

    return itemId;
  }

  private mounted() {
    const pHeight = document.documentElement.clientHeight * 0.6;
    const pop: any = document.getElementById("popslot");
    // console.log("pop", pop);
    pop.style.height = pHeight * 0.85 + "px";

    const contentbody: any = document.getElementById("popscrollbody");
    contentbody.style.height = pHeight * 0.8 + "px";
    let targetY: any;
    contentbody.addEventListener("touchstart", (e: any) => {
      targetY = Math.floor(e.targetTouches[0].clientY);
    });
    contentbody.addEventListener(
      "touchmove",
      (e: any) => {
        const NewTargetY = Math.floor(e.targetTouches[0].clientY);
        const sTop = contentbody.scrollTop;
        const sH = contentbody.scrollHeight;
        const bH = contentbody.clientHeight;

        if (sTop <= 0 && NewTargetY - targetY > 0) {
          e.preventDefault();
        } else if (sTop >= sH - bH && NewTargetY - targetY < 0) {

          e.preventDefault();
        }
      },
      { passive: false }
    );
  }
}
